module.exports = __webpack_public_path__ + "static/logo-rmit-link-5e7fe799ce630dae144f4d9daebb96e9.png";